export const PageUrl = {
    home: {
        url: '/home',
    },
    dashboard: {
        url: '/dashboard',
    },
    commentList: {
        url: '/productcomments/comment-list',
    },
    commentDetail: {
        url: '/productcomments/comment-detail',
    },
    commentTicket: {
        url: '/productcomments/comment-ticket',
    },
    commentRejectReason: {
        url: '/productcomments/comment-reject-reason',
    },
    menuManagement: {
        url: '/sitemanagement/menu-management',
    },
    authorizationRuleManagement: {
        url: '/sitemanagement/authorization-rule-management',
    },
    authorizationManage: {
        url: '/sitemanagement/authorization-manage',
    },
    listUserRoles: {
        url: '/list-user-roles',
    },
    cacheManagement: {
        url: '/sitemanagement/cache-management',
    },
    editUser: {
        url: '/sitemanagement/edit-user',
    },
    editRoles: {
        url: '/sitemanagement/edit-roles',
    },
    storeLcWaikiki: {
        url: '/storelcwaikiki',
    },
    storeLcWaikikiV2: {
        url: '/storelcwaikikiV2',
    },
    paymentLogs: {
        url: '/paymentlogs',
    },
    shippingCompanyRequest: {
        url: '/shippingCompanyRequest',
    },
    MPPrepareReturnToSellerList: {
        url: '/MPPrepareReturnToSellerList',
    },
    billingService: {
        url: '/billingService',
    },
    ofsLogs: {
        url: '/ofsLogs',
    },
    billingGoal: {
        url: '/billingGoal',
    },
    billingQuery: {
        url: '/billingQuery',
    },
    returnList: {
        url: '/returnList',
    },
    returnRejectEntegration: { url: '/returnRejectEntegration' },
    createReturn: {
        url: '/createReturn',
    },
    returnDetail: {
        url: '/returnDetail',
    },
    returnDetailV2: {
        url: '/returnDetailV2',
    },
    returnStatusManagement: {
        url: '/return-status-management',
    },
    refund: {
        url: '/refund',
    },
    refundV2: {
        url: '/refundV2',
    },
    cacheTeam: {
        url: '/cacheteam',
    },
    designCollective: {
        url: '/designcollective',
    },
    storePickUp: { url: '/storepickup' },
    storeReturn: { url: '/storereturn' },
    storeList: {
        url: '/storelist',
    },
    mpConfig: {
        url: '/mpConfig',
    },
    mpConfigV2: {
        url: '/mpConfigV2',
    },
    runtimeConfiguration: {
        url: '/runtime-configuration',
    },
    runtimeConfigurationCreate: {
        url: '/runtime-configuration/create',
    },
    runtimeConfigurationDetail: {
        url: '/runtime-configuration/detail',
    },
    mpApplicationHandler: {
        url: '/mpApplicationHandler',
    },
    mpApplicationHandlerV2: {
        url: '/mpApplicationHandlerV2',
    },
    mpClientTranslations: {
        url: '/mpClientTranslations',
    },
    transferCargoData: {
        url: '/creatingLabelShippingList',
    },
    serviceManagment: {
        url: '/serviceManagment',
    },
    lcwMoney: {
        url: '/lcwMoney',
    },
    shippingPerformance: {
        url: '/shippingPerformance',
    },
    failedInvoice: {
        url: '/failedInvoice',
    },
    searchService: {
        url: '/searchService',
    },
    orders: {
        url: '/orders',
    },
    billingErrorLog: {
        url: '/billingErrorLog',
    },
    menuManagementAll: {
        url: '/sitemanagement/applicationManagement',
    },
    testServicesUrl: {
        url: '/sitemanagement/testServicesUrl',
    },
    retailDb: {
        url: '/deleteRetailId',
    },
    detailStockSearch: {
        url: '/detailStockSearch',
    },
    productTransfer: {
        url: '/productTransfer',
    },
    ssrsPage: {
        url: '/ssrsPage',
    },
    ssrsPageManagement: {
        url: '/ssrsPageManagement',
    },
    orderFraudControl: {
        url: '/orderFraudControl',
    },
    localizationManagement: {
        url: '/localizationManagement',
    },
    smsTemplate: {
        url: '/smsTemplate',
    },
    emailAndSmsServiceLogs: {
        url: '/emailAndSmsServiceLogs',
    },
    orderNotFinance: {
        url: '/orderNotFinance',
    },
    productSearch: {
        url: '/productSearch',
    },
    productDetail: {
        url: '/productDetail/:optionId',
    },
    productDashboard: {
        url: '/productDashboard',
    },
    refundProcessNo: {
        url: '/refundProcessNo',
    },
    storeCustomerService: {
        url: '/storeCustomerService',
    },
    storeCustomerManagement: {
        url: '/store-customer-management',
    },
    storeCustomerOrderManagement: {
        url: '/storeCustomerManagement',
    },
    cargoManagement: {
        url: '/cargoManagement',
    },
    cargoManagementV2: {
        url: '/cargoManagementV2',
    },
    customerManagement: {
        url: '/customerManagement',
    },
    customerDiagnostics: {
        url: '/customer-diagnostics',
    },
    imageSearch: {
        url: '/imageSearch',
    },
    imageSearchV2: {
        url: '/imageSearchV2',
    },
    greetingNotes: {
        url: '/greetingNotes',
    },
    cargoFeeManagement: {
        url: '/cargoFeeManagement',
    },
    emailTemplateBuilder: {
        url: '/emailTemplateBuilder',
    },
    sectionGallery: {
        url: '/emailTemplateBuilder/sectionGallery',
    },
    templateGallery: {
        url: '/emailTemplateBuilder/templateGallery',
    },
    createTemplate: {
        url: '/emailTemplateBuilder/createTemplate',
    },
    sendTestMail: {
        url: '/emailTemplateBuilder/send-test-mail/:templateKey',
    },
    RPAResend: {
        url: '/RPAResender',
    },
    autoReturnAndResend: {
        url: '/auto-return-and-resend',
    },
    RpaRequestManagement: {
        url: '/rpa-request-management',
    },
    addSection: {
        url: '/emailTemplateBuilder/addSection',
    },
    editSection: {
        url: '/emailTemplateBuilder/editSection/:sectionId',
    },
    dynamicRequest: {
        url: '/dynamicRequest',
    },
    petition: {
        url: '/petitionRefundList',
    },
    petitionV2: {
        url: '/petitionRefundListV2',
    },
    refundlistV2: {
        url: '/refundlistV2',
    },
    ruleService: {
        url: '/rule-management',
    },
    ruleServiceV2: {
        url: '/rule-managementV2',
    },
    mobileFieldCargoDistribution: {
        url: '/mobileFieldCargoDistribution',
    },
    orderDetail: {
        url: '/orderDetail',
    },
    shippingCancelReason: {
        url: '/shippingCancelReason',
    },
    customerCommentApprovalPage: {
        url: '/customerCommentApprovalPage',
    },
    CustomerAnonymization: {
        url: '/CustomerAnonymization',
    },
    CustomerAnonymizationHistory: {
        url: '/CustomerAnonymizationHistory',
    },
    StoreReturnSearch: {
        url: '/StoreReturnSearch',
    },
    shippingListStatusManagement: {
        url: '/shippingListStatusManagement',
    },
    rptTopicManagement: {
        url: '/rptTopicManagement',
    },
    storeDeliveryOrders: {
        url: '/storeDeliveryOrders',
    },
    cookieManagement: {
        url: '/cookieManagement',
    },
    cookieType: {
        url: '/cookieType',
    },
    commentListV2: {
        url: '/productcomments/comment-list-v2',
    },
    digitalCard: {
        url: '/digitalCard',
    },
    expenseNote: {
        url: '/expenseNote',
    },
    globaldatatokenmanagement: {
        url: '/sitemanagement/global-data-token-management',
    },
    shippingcompanylabel: {
        url: '/shippingcompanylabel',
    },
    cargoPrioritization: {
        url: '/cargoPrioritization',
    },
    paymentConsolidation: {
        url: '/payment-consolidation',
    },
    scheduleService: {
        url: '/schedule-service',
    },
    scheduleDetail: {
        url: '/schedule-service-detail/:scheduleId',
    },
    estimatedShippingDate: {
        url: '/estimated-shipping-date',
    },
    scheduleGroups: {
        url: '/schedule-groups',
    },
    userGroup: {
        url: '/group-users/:groupId',
    },
    globalData: {
        url: '/global-data',
    },
    globalDataCacheManagement: {
        url: '/global-data-cache-management',
    },
    masterData: {
        url: '/master-data',
    },
    orderPrio: {
        url: '/order-prioritization',
    },
    goalStatusSending: {
        url: '/goal-status-sending',
    },
    lostCargo: {
        url: '/lost-cargo',
    },
    jsonTemplate: {
        url: '/json-template',
    },
    addJsonTemplate: {
        url: '/json-template/add-json-template',
    },
    editJsonTemplate: {
        url: '/json-template/edit-json-template/:templateId',
    },
    storePickupPackageAdmission: {
        url: '/store-pickup-package-admission',
    },
    forcePasswordReset: {
        url: '/forcePasswordReset',
    },
    lostCargoReturnPage: {
        url: '/lost-cargo-return-page',
        detailUrl: '/lost-cargo-return-detail-page',
    },
    studioRoutes: {
        itemAcceptanceCancellation: { url: '/studio/item-acceptance-cancellation' },
        planningList: { url: '/studio/planning-list' },
        planningDetail: { url: '/studio/planning-detail/:planningId' },
        planningCreate: { url: '/studio/planning-create' },
        fileManager: { url: '/studio/file-manager' },
        grpcFileManager: { url: '/studio/file-grpc-manager' },
        legacyTransferImport: { url: '/studio/legacy-transfer-import' },
        retouch: { url: '/studio/retouch' },
        ipWhiteList: { url: '/studio/ip-whitelist' },
        syncTableState: { url: '/studio/sync-table-state' },
        mannequinList: { url: '/studio/mannequin' },
        mannequinCreate: { url: '/studio/mannequin/create' },
        mannequinEdit: { url: '/studio/mannequin/edit/:id' },
        aiGeneration: { url: '/studio/ai-generation' },
        aiGenerationModel: { url: '/studio/ai-generation/model' },
        aiGenerationHanger: { url: '/studio/ai-generation/generate-card' },
        aiGenerationHistory: { url: '/studio/ai-generation/history' },
        aiStudioAnalytics: { url: '/studio/ai-studio-analytics' },
        productGenerationReport: { url: '/studio/product-generation-report' },
        studyoPromptList: { url: '/studio/studyo-prompt' },
        backgroundLabelManagement: { url: '/studio/background-label-management' },
        aiGenerationTypeManagement: { url: '/studio/ai-generation-type-management' },
        addressBarcodeManagement: { url: '/studio/address-barcode-management' },
        addressBarcodeInformation: { url: '/studio/address-barcode-information' },
        productShotHistory: { url: '/studio/product-shot-history' },
        studioShotReport: { url: '/studio/studio-shot-report' },
        studioProductStatusFlowReport: { url: '/studio/studio-product-status-flow-report' },
        matchingSetPendingReport: { url: '/studio/matching-set-pending-report' },
        pendingRetouchTransfers: { url: '/studio/pending-retouch-transfers' },
        bulkImageUpload: { url: '/studio/bulk-image-upload' },
        rawImageFrameControl: { url: '/studio/raw-image-frame-control' },
        batchOutputControl: { url: '/studio/batch-output-control' },
        batchProcessTracking: { url: '/studio/batch-process-tracking' },
        barcodeProductionHistory: { url: '/studio/barcode-history/:barcode' },
    },
    summary: {
        url: '/summary-list',
        detailUrl: '/summary-detail/:summaryId',
    },
    summaryV2: {
        url: '/summary-list-v2',
        detailUrl: '/summary-detail-v2/:summaryId',
    },
    summaryAggregation: {
        netSales: { url: '/summary-aggregation/net-sales' },
        summaryList: { url: '/summary-aggregation/summary-list' },
        summaryDetailSearch: { url: '/summary-aggregation/summary-detail-search' },
    },
    fastDeliveryCargoManagement: {
        url: '/fast-delivery-cargo-management',
    },
    redisCacheManagement: {
        url: '/redis-cache-management',
    },
    lcwCargoFeeManagement: {
        url: '/lcw-cargo-fee-management',
    },
    noOrderShotSearch: {
        url: '/no-order-shot-search',
    },
    pendingRoleRequests: {
        url: '/role-approval/pending-requests',
    },
    requestRole: {
        url: '/role-approval/request-role',
    },
    requestRoleGuide: {
        url: '/role-approval/request-role-guide',
    },
    myRoleRequests: {
        url: '/role-approval/my-requests',
    },
    mpCargoFeeManagement: {
        url: '/mp-cargo-fee-management',
    },
    mpPaymentOnDeliveryCommission: {
        url: '/mp-payment-on-delivery-commission',
    },
    mpBulkShipmentUpdate: {
        url: '/mp-bulk-shipment-update',
    },
    hiddenExcel: {
        url: '/hidden-excel',
    },
    binNumberManagement: {
        url: '/bin-number-management',
    },
    growManagement: {
        url: '/grow-management',
    },
    otpPassword: {
        url: '/password-sms-management',
    },
    membershipSmsManagement: {
        url: '/sms-account-management',
    },
    cutOff: {
        url: '/cut-off',
    },
    cargoAddressBlocking: {
        url: '/cargo-address-blocking',
    },
    storeCargoBlocking: {
        url: '/store-cargo-blocking',
    },
    financeReport: {
        url: '/finance-report',
    },
    cargoCompanyDistributionAreas: {
        url: '/cargo-company-distribution-areas',
    },
    auditLogs: {
        url: '/audit-log',
    },
    akbankTransactionStatusList: {
        url: '/akbank-transaction-status-list',
    },
    aiPromptManagement: {
        url: '/ai-prompt-management',
    },
    s3Browser: {
        url: '/s3-browser',
    },
    aiPromptManagementS3Test: {
        url: '/ai-prompt-management/test',
    },
    taskAnalyzer: {
        url: '/task-analyzer',
    },
    cargoReconciliationIFrame: {
        url: '/cargo-reconciliation-iframe',
    },
    postCheckoutInsights: {
        url: '/fix-insights',
    },
    customerCommunicationPrefrencesReport: {
        url: '/customer-communication-preferences-report',
    },
    cardBalanceInquiry: {
        url: '/gift-card-transaction-report',
    },
    dailyPlanner: {
        url: '/daily-planner',
    },
    mobileExpressFraud: {
        url: '/mobile-express-fraud',
    },
    etbisReports: {
        url: '/etbis-reports',
    },
    growCategoryRestriction: {
        url: '/grow-category-restriction',
    },
    storeManagerStaffPermission: {
        url: '/store-manager/staff-permissions',
    },
    storeManagerPermissionHistory: {
        url: '/store-manager/permission-history',
    },
    mobileProductCapture: {
        url: '/mobile-product-capture',
    },
    returnIpLogReport: {
        url: '/return-ip-log-report',
    },
    retroBoard: {
        url: '/retro',
    },
    paylens: {
        url: '/paylens',
    },
    paylensPayment: {
        url: '/paylens-payment',
    },
    growWorkingDays: {
        url: '/grow-working-days',
    },
};
